<template>
  <div
    :class="[
      'p-8 text-center rounded-lg border-2 border-dashed cursor-pointer transition-all duration-300',
      uploading
        ? 'opacity-60 pointer-events-none border-nera-border bg-black/20'
        : (isDragOver ? 'border-nera-accent bg-nera-accent/10' : 'border-nera-border bg-black/20 hover:border-nera-accent hover:bg-nera-accent/10')
    ]"
    @click="$refs.fileInput.click()"
    @drop.prevent="handleDrop"
    @dragover.prevent="isDragOver = true"
    @dragleave="isDragOver = false"
  >
    <input
      ref="fileInput"
      type="file"
      accept=".xlsx,.xls"
      @change="handleFileSelect"
      class="hidden"
    />

    <div class="text-nera-text">
      <span class="block mb-2 text-nera-accent">
        <i class="fas fa-cloud-upload-alt fa-2x"></i>
      </span>
      <p v-if="!uploading">
        <strong>Drop file here</strong> or click to select
      </p>
      <p v-else>
        <strong>Uploading...</strong>
      </p>
      <p class="text-nera-muted text-sm mt-2">Excel files only</p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
  uploading: Boolean
})

const emit = defineEmits(['file-selected'])

const fileInput = ref(null)
const isDragOver = ref(false)

const handleFileSelect = (e) => {
  const file = e.target.files[0]
  if (file) {
    emit('file-selected', file)
  }
  e.target.value = ''
}

const handleDrop = (e) => {
  isDragOver.value = false
  const file = e.dataTransfer.files[0]
  if (file) {
    emit('file-selected', file)
  }
}
</script>
